import * as React from 'react';
import MinusButton from '../Buttons/MinusButton';
import PlusButton from '../Buttons/PlusButton';
import styled from 'styled-components';

const PlusMinusSelectorContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
`;

const SelectorText = styled.p`
  display: flex;
  justify-content: center;
  align-items: center;
  font-style: normal;
  font-weight: normal;
  line-height: normal;
  font-size: 20px;
  text-align: center;
  width: 36px;
  color: #4f4f4f;
  margin-bottom: 0;
`;

interface prop {
  onChange?: ((value: number) => void);
  value?: number;
}

interface state {
  value: number;
}

class PlusMinusSelector extends React.Component<prop, state> {
  state = {
    value: this.props.value || 0,
  };

  render() {
    return (
      <PlusMinusSelectorContainer>
        <MinusButton onClick={this.minusButtonClicked} />
        <SelectorText>{this.state.value}</SelectorText>
        <PlusButton onClick={this.plusButtonClicked} />
      </PlusMinusSelectorContainer>
    );
  }

  minusButtonClicked = () => {
    if (this.state.value > 0) {
      this.setState(
        {
          value: this.state.value - 1,
        },
        () => {
          this.props.onChange && this.props.onChange(this.state.value);
        },
      );
    }
  };

  plusButtonClicked = () => {
    this.setState(
      {
        value: this.state.value + 1,
      },
      () => {
        this.props.onChange && this.props.onChange(this.state.value);
      },
    );
  };
}

export default PlusMinusSelector;



// WEBPACK FOOTER //
// ./src/components/FormComponents/PlusMinusSelector.tsx